// ✅ Updated React Page to Test SalesFlow Excel Upload and Delete APIs

import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import loaderGif from "../assets/Img/loading1.gif";
import "../assets/CSS/Dashboard.css";

export default function SalesFlowExcel() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedLot, setSelectedLot] = useState("");
  const [lotIds, setLotIds] = useState([]);
  const [deleting, setDeleting] = useState(false);
  const fileInputRef = useRef(null);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchLotIds = async () => {
    try {
      const res = await axiosInstance.get("/api/sales-flow/lotids");
      setLotIds(res.data.lotIds || []);
    } catch (err) {
      console.error("Error loading LOT IDs:", err);
    }
  };


  useEffect(() => {
    fetchLotIds();
  
  }, []);

  const handleFileChange = (e) => setSelectedFile(e.target.files[0] || null);

  const handleUpload = async () => {
    if (!selectedFile) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", selectedFile);
    try {
      const res = await axiosInstance.post("/api/upload-sales-excel", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      showAlert(res.data.message, "success");
      fileInputRef.current.value = null;
      setSelectedFile(null);
      fetchLotIds();
  
    } catch (err) {
      console.error("Upload failed:", err);
      showAlert("Upload failed.", "error");
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedLot) return;
    if (!window.confirm(`Delete records for ${selectedLot}?`)) return;
    setDeleting(true);
    try {
      const res = await axiosInstance.delete(`/api/delete-salesflow/${selectedLot}`);
      showAlert(res.data.message, "success");
      setSelectedLot("");
      fetchLotIds();
     
    } catch (err) {
      console.error("Delete failed:", err);
      showAlert("Delete failed.", "error");
    } finally {
      setDeleting(false);
    }
  };

  const showAlert = (msg, type) => {
    const ph = document.getElementById("alertPlaceholder");
    ph.innerHTML = `<div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${msg}
        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
      </div>`;
    setTimeout(() => (ph.innerHTML = ""), 3000);
  };


  return (
    <div className="d-flex dashboard">
      {uploading && (
        <div className="overlay">
          <img src={loaderGif} alt="Uploading..." className="loader" />
        </div>
      )}
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4">
          <div id="alertPlaceholder" />
          <h3 className="mb-4">SalesFlow Excel Upload</h3>

          <div className="d-flex mb-4 gap-4">
            <div>
              <label className="form-label">Upload Excel:</label>
              <input type="file" accept=".xlsx,.xls" className="form-control" ref={fileInputRef} onChange={handleFileChange} />
              <button
                className="btn btn-primary mt-2"
                onClick={handleUpload}
                disabled={uploading || !selectedFile}
              >
                {uploading ? "Uploading..." : "Upload"}
              </button>
            </div>
            <div>
              <label className="form-label">Delete by LOT ID:</label>
              <select
                className="form-select"
                value={selectedLot}
                onChange={(e) => setSelectedLot(e.target.value)}
              >
                <option value="">-- Select LOT ID --</option>
                {lotIds.map((lot, i) => (
                  <option key={i} value={lot}>{lot}</option>
                ))}
              </select>
              <button className="btn btn-danger mt-2" onClick={handleDelete} disabled={!selectedLot || deleting}>
                {deleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>

    
        </main>
      </div>
    </div>
  );
}
